<template lang="pug">
  lazy-load(
    v-bind="$attrs"
    v-on="$listeners"
  )
    v-sheet(color="transparent")
      v-skeleton-loader(
        v-if="loading"
        type="list-item@3"
      )
      v-list(v-else)
        v-list-item(v-if="!activeEnrollments.length")
          v-list-avatar
            v-icon.mr-4 mdi-bulletin-board
          v-list-item-content
            v-list-item-subtitle Наборов не найдено...
        v-list-item(
          v-for="enrollment in activeEnrollments"
          :key="enrollment.id"
          :disabled="enrollment.hasRecord"
          @click="$emit('click:enrollment', enrollment)"
        ).mb-2
          v-list-item-avatar
            v-avatar(
              :disabled="enrollment.hasRecord"
              color="secondary lighten-1"
            ).caption.white--text {{ enrollment.code }}
          v-list-item-content
            v-list-item-title
              | {{ enrollment.start_learning | dp('d MMMM y') }} -
              |  {{ enrollment.end_learning | dp('d MMMM y') }}
              .caption.opacity(v-if="!enrollment.hasRecord") Период обучения
            v-list-item-subtitle
              v-chip(
                v-if="enrollment.hasRecord"
                :disabled="enrollment.hasRecord"
                small color="info"
              ) уже есть запись
</template>

<script>
import { isWithinInterval } from 'date-fns';

export default {
  props: {
    enrollments: { type: Array, required: true },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    activeEnrollments() {
      return this.enrollments.filter(
        ({ period_start: start, period_end: end }) => isWithinInterval(new Date(), {
          start: new Date(start),
          end: new Date(end),
        }),
      );
    },
  },
  async created() {
    await Promise.all(this.enrollments.map(async (i, idx) => {
      this.$set(this.enrollments[idx], 'hasRecord', await this.getEnrolments(i.id));
    }));
    this.loading = false;
  },
  methods: {
    async getEnrolments(id) {
      const { data } = await this.$api.enrollments.getEnrollmentUserList(id);
      const usersId = data.data.users.map((i) => i.id);
      return usersId.includes(this.$user.data.id);
    },
  },
};
</script>
